// Баннер розыгрыша на главном экране: сколько заданий осталось до участия, «вы участвуете» и таймер,
// «розыгрыш идёт», итог. Тап — экран «Розыгрыш». Показывать ли, решает сервер (lottery.js): во всех
// приложениях, где деньги идут на наш баланс, — и тем, кто сегодня не участвует (итоги видны всем).
// isUpmob — только в чём показывать суммы (💎 или ₽).
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { LotteryApi } from '../../components_android/api/LotteryApi';
import { Pages } from '../custom_views/insta_custom_views/utils_android/UtilsAndroid';
import { getCookie } from '../custom_views/insta_custom_views/utils_android/CookieHelper';
import { countdownText, drawTimeText, finalistPrize, placeText, plural, prizesOf, prizesShort, prizeText, withDot } from './lotteryTexts';
import { syncPrizeBalance } from './prizeSync';
import '../../css_android/lottery.css';

// Приложения партнёров выплачивают исполнителям сами — розыгрыша там нет (сервер ответит так же),
// лишний раз не спрашиваем
const PARTNER_KEYS = ['easyMoney', 'AdCoin', 'AppOffers'];

export default function LotteryBanner({ isUpmob, refreshInfo }) {
    const [data, setData] = useState(null);
    const [, setTick] = useState(0);
    const offsetRef = useRef(0);
    const refreshRef = useRef(refreshInfo);
    refreshRef.current = refreshInfo;

    useEffect(() => {
        if (PARTNER_KEYS.indexOf(getCookie('api_key')) !== -1) return undefined;
        let alive = true;
        let timer = 0;
        const load = () => LotteryApi.state((d) => {
            if (!alive || d.response !== 1) return;
            offsetRef.current = d.now - Date.now();
            setData(d);
            // обновить надпись: к началу розыгрыша, а во время показа — до объявления победителя
            clearTimeout(timer);
            const t = d.enabled && d.today;
            // своё место уже объявлено (приз зачислен) — баланс в шапке обновить с сервера, один раз за розыгрыш
            const mine = t && t.show ? (t.show.finalists || []).filter((f) => f.you && f.place)[0] : null;
            if (mine && finalistPrize(mine, t.show) > 0) syncPrizeBalance(t.day, refreshRef.current);
            if (t && t.phase === 'open' && t.draw_at > d.now && t.draw_at - d.now < 6 * 3600000) {
                timer = setTimeout(load, t.draw_at - d.now + 2000 + Math.random() * 3000);
            } else if (t && (t.phase === 'live' || (t.phase === 'open' && t.draw_at <= d.now))) {
                const next = t.show && t.show.next;
                const wait = next && next.kind === 'winner' ? next.at - d.now : 10000;
                timer = setTimeout(load, Math.max(2000, Math.min(wait, 15000)) + Math.random() * 2000);
            }
        }, () => {});
        load();
        const tick = setInterval(() => setTick((x) => x + 1), 1000);
        const onVisible = () => { if (!document.hidden) load(); };
        document.addEventListener('visibilitychange', onVisible);
        return () => {
            alive = false;
            clearTimeout(timer);
            clearInterval(tick);
            document.removeEventListener('visibilitychange', onVisible);
        };
    }, []);

    if (!data || !data.enabled || !data.today) return null;
    const t = data.today;
    const me = t.me || {};
    const now = Date.now() + offsetRef.current;
    const prizes = prizesShort(prizesOf(data), isUpmob);
    const time = drawTimeText(data.hour, data.minute);
    let title;
    let sub;
    let live = false;
    if (t.phase === 'open' && now < t.draw_at) {
        if (me.joined) {
            title = 'Вы участвуете в розыгрыше ' + prizes;
            sub = 'Начало через ' + countdownText(t.draw_at - now);
        } else if (me.can_join) {
            title = 'Можно участвовать в розыгрыше ' + prizes;
            sub = 'Вы выполнили ' + data.min_tasks + ' ' + plural(data.min_tasks, 'задание', 'задания', 'заданий') + ' — нажмите «Участвовать»';
        } else {
            title = 'Розыгрыш ' + prizes + ' — сегодня\u00A0в\u00A0' + time;
            sub = 'Заданий выполнено: ' + Math.min(me.tasks || 0, data.min_tasks) + ' из ' + data.min_tasks;
        }
    } else if (t.phase === 'open' || t.phase === 'live') {
        live = true;
        title = 'Идёт розыгрыш призов';
        sub = 'Смотреть в прямом эфире';
    } else if (t.phase === 'finished' && t.show && t.show.winner) {
        const mine = (t.show.finalists || []).filter((f) => f.you && f.place)[0];
        const amount = finalistPrize(mine, t.show);
        if (t.show.winner.you) {
            title = 'Вы выиграли розыгрыш! 🎉';
            sub = prizeText(amount || t.show.prize, isUpmob) + ' уже на балансе';
        } else if (mine && amount > 0) {
            title = 'Вы заняли ' + placeText(mine.place) + ' в розыгрыше! 🎉';
            sub = prizeText(amount, isUpmob) + ' уже на балансе';
        } else {
            title = 'Розыгрыш завершён';
            sub = withDot('Победитель — ' + t.show.winner.name) + ' Следующий — завтра в ' + time;
        }
    } else {
        title = 'Розыгрыш ' + prizes;
        sub = 'Следующий — завтра в ' + time;
    }
    return (
        <Link to={'/' + Pages.lottery} className={'lottery_banner' + (live ? ' is_live' : '')}>
            <span className="lottery_banner_icon" aria-hidden="true">{live ? '' : '🎁'}{live && <i className="lottery_banner_dot" />}</span>
            <span className="lottery_banner_text">
                <span className="lottery_banner_title">{title}</span>
                <span className="lottery_banner_sub">{sub}</span>
            </span>
            <span className="lottery_banner_arrow" aria-hidden="true">›</span>
        </Link>
    );
}
